/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SysqueTextBoxDescriptionComponent } from './sysque-text-area-description.component';
import { DxTextAreaModule } from 'devextreme-angular';

@NgModule({
  declarations: [SysqueTextBoxDescriptionComponent],
  imports: [CommonModule, DxTextAreaModule],
  exports: [SysqueTextBoxDescriptionComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SysqueTextBoxDescriptionModule {}
